export const ConvertToProductTemplateCodeList = (productTemplateCodeListRaw: any) => {
  const productTemplateCodeList = [];
  if (productTemplateCodeListRaw && productTemplateCodeListRaw.length > 0) {
    for (const productTemplateCodeRaw of productTemplateCodeListRaw) {
      productTemplateCodeList.push({
        id: productTemplateCodeRaw.id,
        productTemplateCode: productTemplateCodeRaw.productTemplateCode,
      });
    }
  }
  return productTemplateCodeList;
};
